var map = {
	"./InfiniteSlider": 2972,
	"./InfiniteSlider.css": 3913,
	"./InfiniteSlider.js": 2972,
	"./Landing": 7614,
	"./Landing.css": 7085,
	"./Landing.jsx": 7614,
	"./bg.mp4": 759,
	"./imgs/automation.png": 6459,
	"./imgs/nextmove.png": 4962,
	"./imgs/penta.png": 6464,
	"./imgs/product.png": 697,
	"./imgs/proline.png": 3071,
	"./imgs/sitemark.png": 2204,
	"./imgs/vision.png": 6658,
	"./imgs/waveless.png": 4550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3304;